import {css} from 'aphrodite';
import React from 'react';

import {NODE_HEADER_HANDLE_STYLES} from 'ui-library/reactflow/nodes/BenchlingNode/BenchlingNodeDesignConstants';

export default function HandleDot(): JSX.Element {
  return <div className={css(NODE_HEADER_HANDLE_STYLES.handleDot)} />;
}
